module.exports = __webpack_public_path__ + "img/qatar.5393ff29.svg";